import { Component,EventEmitter,Optional} from '@angular/core';
import { FormBuilder,Validators,ControlContainer,FormGroup  } from '@angular/forms';
import { Router } from '@angular/router';
import { ManageBeneFormHelper,ManageBeneFormState} from './manage-bene-form.helper';
import { BaseFpxFormComponent,ValidatorService } from '@fpx/core';
import { BeneficiariesService } from '../beneficiaries-service/beneficiaries.service';
import { Beneficiaries } from '../beneficiaries-service/beneficiaries.model';
import { ProcessShellService } from 'src/app/process-shell/services/process-shell.service';


@Component({
 selector: 'app-manage-bene-form',
  templateUrl: './manage-bene-form.component.html',
  styleUrls: ['./manage-bene-form.component.scss'],
  providers : [ ManageBeneFormHelper]
  })

export class ManageBeneFormComponent extends BaseFpxFormComponent<ManageBeneFormHelper, ManageBeneFormState> {
  constructor(
    @Optional() controlContainer: ControlContainer,
    formBuilder: FormBuilder,
    private router: Router,
    public manageBeneFormHelper: ManageBeneFormHelper,
    public beneficiariesService: BeneficiariesService,
    private validatorService: ValidatorService,
    protected processShellService:ProcessShellService

  ) {
    super(formBuilder, router,controlContainer, manageBeneFormHelper);
  }
   protected override doPreInit(): void {
    this.addFormControl('beneFilterRadio', '', [Validators.required]    ,[],'change' );

    // this.addFormControl('beneList', '', []    ,[],'change' );
	this.setDataService(this.beneficiariesService);
  }


  protected override doPostInit(): void {

  }

}
